'use client';
import type { PropsWithChildren } from 'react';
import { dynamic } from '../../../../external/dynamic';
import { InterfaceModes } from '../../InterfaceStore/types';
import { RunnerGlobalAppStateStoreProvider } from './runner/GlobalAppStateStoreProvider';
import type { WithRemountProps } from './types';

const BuilderGlobalAppStateStoreProvider = dynamic(
  () =>
    import(
      /* webpackChunkName: "builder-global-app-state-store-provider" */ './builder/GlobalAppStateStoreProvider'
    ),
);

function GlobalAppStateStoreProvider(props: PropsWithChildren<WithRemountProps>) {
  const { mode } = props;

  if (mode === InterfaceModes.RUNNER) {
    return <RunnerGlobalAppStateStoreProvider {...props} />;
  }

  return <BuilderGlobalAppStateStoreProvider {...props} />;
}

export default GlobalAppStateStoreProvider;
